import isInViewport from './isInViewPort'

export enum ElementPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
  IN = 'in',
}

function whereIsElement(element: HTMLElement) {
  if (isInViewport(element)) {
    return ElementPosition.IN
  }

  const rect = element.getBoundingClientRect()

  if (rect.top < 0) {
    return ElementPosition.TOP
  }

  if (
    rect.bottom > (window.innerHeight || document.documentElement.clientHeight)
  ) {
    return ElementPosition.BOTTOM
  }

  return ElementPosition.BOTTOM
}

export default whereIsElement
